import React from 'react';
import { Card } from '@repo/ui/Card';
import { useAccount } from '@/hooks/useAccount';

import { QuickLinks, QuickLinkType } from '@repo/ui/QuickLinks';

import SupportPlansViewTable from './SupportPlansViewTable';

const SupportOverview = () => {
  const account = useAccount();

  const links: QuickLinkType[] = [
    {
      title: 'Email Support',
      description: 'support@swiftsmsgateway.com ',
      href: 'mailto:support@swiftsmsgateway.com',
      icon: 'mail',
    },
  ];

  const EnterpriseSupportLinks: QuickLinkType[] = [
    {
      title: 'Email Support',
      description: 'entsupport@swiftsmsgateway.com ',
      href: 'mailto:entsupport@swiftsmsgateway.com ',
      icon: 'mail',
    },
    {
      title: 'Phone Support',
      description: '1-800-264-7141 Ext 711',
      href: 'tel:+18002647141,711',
      icon: 'phone',
    },
  ];

  const ProfessionalSupportLinks: QuickLinkType[] = [
    {
      title: 'Email Support',
      description: 'prosupport@swiftsmsgateway.com',
      href: 'mailto:prosupport@swiftsmsgateway.com',
      icon: 'mail',
    },
    {
      title: 'Phone Support',
      description: '1-800-264-7141 Ext 2',
      href: 'tel:+18002647141,2',
      icon: 'phone',
    },
  ];

  const StandardSupportLinks: QuickLinkType[] = [
    {
      title: 'Email Support',
      description: 'support@swiftsmsgateway.com',
      href: 'mailto:support@swiftsmsgateway.com',
      icon: 'mail',
    },
  ];

  const getDescription = (planName?: string) => {
    switch (planName) {
      case 'Enterprise Support':
        return 'Support Hours: 24/7/365';
      case 'Professional Support':
        return 'Support Hours: 8 am to 8 pm EST';
      default:
        return '';
    }
  };

  const getLinks = (planName?: string) => {
    switch (planName) {
      case 'Enterprise Support':
        return EnterpriseSupportLinks;
      case 'Professional Support':
        return ProfessionalSupportLinks;
      default:
        return StandardSupportLinks;
    }
  };

  return (
    <>
      <Card
        size="sm"
        title="Status Updates"
        description="For status update notifications please subscribe to our status page.  Contacting support is to address topics specific to your account."
      >
        <QuickLinks
          links={[
            {
              title: 'Subscribe to Status Updates',
              href: 'https://status.swiftsmsgateway.com',
              icon: 'area_chart',
              external: true,
            },
          ]}
        />
      </Card>

      <Card
        title={`Current Support Plan: ${account?.supportPlan?.name}`}
        description={` Submitting an email to support will create a support ticket and will be directed to the appropriate department depending upon subject matter. ${getDescription(account?.supportPlan?.name)}.`}
        size="sm"
      >
        <QuickLinks links={getLinks(account?.supportPlan?.name) || []} />
      </Card>

      <SupportPlansViewTable planName={account?.supportPlan?.name} />
    </>
  );
};

export default SupportOverview;
